import { FORMAT_TYPE } from 'cyprus/enums';

import { CURRENCY_EXPRESSION, DEFAULT_INVALID, DEFAULT_REPLACE } from '../constants';
import { FormatValue, FormatValueOptions } from '../types';
import { abbreviateNumber, invalidNumber } from '../utils';

export const formatCurrency = (value: FormatValue, options: FormatValueOptions): string => {
  const { format } = options;
  const ignore = options.ignore || [];
  const decimal = Number(options.decimal || 0);
  const scale = Number(options.scale || 0);
  const number = Number(value);

  const match = ignore.includes(String(value));

  if (match) {
    return options.replace || DEFAULT_REPLACE;
  }

  if (invalidNumber(value)) {
    return options.invalid || DEFAULT_INVALID;
  }

  const abs = Math.abs(number);
  const negative = Math.sign(number) === -1;

  switch (format) {
    case FORMAT_TYPE.CURRENCY:
      // determine negative and positive currencies and always adds cents
      // ex. 12.3123 => $12.31
      // ex. -12.88 => -$12.88
      // ex. 12 => $12.00
      if (negative) {
        return `-$${String(abs.toFixed(decimal))
          .replace(CURRENCY_EXPRESSION, '$1,')
          .replace(/(\.\d*),/g, '$1')}`;
      }
      return `$${String(abs.toFixed(decimal))
        .replace(CURRENCY_EXPRESSION, '$1,')
        .replace(/(\.\d*),/g, '$1')}`;

    case FORMAT_TYPE.CURRENCY_ABBREVIATED: {
      if (abs < 100) {
        if (negative) {
          return `-$${String(abs.toFixed(2))
            .replace(CURRENCY_EXPRESSION, '$1,')
            .replace(/(\.\d*),/g, '$1')}`;
        }
        return `$${String(abs.toFixed(2))
          .replace(CURRENCY_EXPRESSION, '$1,')
          .replace(/(\.\d*),/g, '$1')}`;
      }
      if (abs < 10000) {
        if (negative) {
          return `-$${String(abs.toFixed(0))
            .replace(CURRENCY_EXPRESSION, '$1,')
            .replace(/(\.\d*),/g, '$1')}`;
        }
        return `$${String(abs.toFixed(0))
          .replace(CURRENCY_EXPRESSION, '$1,')
          .replace(/(\.\d*),/g, '$1')}`;
      }
      if (negative) {
        return `-$${abbreviateNumber(abs, decimal)}`;
      }
      return `$${abbreviateNumber(abs, decimal)}`;
    }
    case FORMAT_TYPE.CURRENCY_SCALE: {
      if (scale < 10) {
        if (negative) {
          return `-$${String(number.toFixed(2))
            .replace(CURRENCY_EXPRESSION, '$1,')
            .replace(/(\.\d*),/g, '$1')}`;
        }
        return `$${String(number.toFixed(2))
          .replace(CURRENCY_EXPRESSION, '$1,')
          .replace(/(\.\d*),/g, '$1')}`;
      }
      if (scale < 100) {
        if (negative) {
          return `-$${String(number.toFixed(0))
            .replace(CURRENCY_EXPRESSION, '$1,')
            .replace(/(\.\d*),/g, '$1')}`;
        }
        return `$${String(number.toFixed(0))
          .replace(CURRENCY_EXPRESSION, '$1,')
          .replace(/(\.\d*),/g, '$1')}`;
      }
      if (negative) {
        return `-$${abbreviateNumber(abs, decimal)}`;
      }
      return `$${abbreviateNumber(abs, decimal)}`;
    }
    default:
      return String(value || '');
  }
};
